import React from 'react';

import { Locales } from 'src/lib/constants';
import { TopicPageTemplate } from 'src/templates';
import {
  getResourcesTopicPaginationStaticPaths,
  getResourcesTopicPaginationStaticProps,
} from 'src/lib/resources-page-data';

const TopicPage = ({ articles, ...props }) => {
  return (
    <TopicPageTemplate articles={articles} locale={Locales.EN_US} {...props} />
  );
};

export async function getStaticPaths() {
  return getResourcesTopicPaginationStaticPaths({ locale: Locales.EN_US });
}

export async function getStaticProps({ params, preview }) {
  return getResourcesTopicPaginationStaticProps({
    locale: Locales.EN_US,
    preview,
    params,
  });
}

export default TopicPage;
